module.exports = __webpack_public_path__ + "static/media/IN.fde888ac.png";